/* eslint-disable @typescript-eslint/no-explicit-any */
import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle<{ theme: any }>`
  ${(props) => props.theme.fontUrls && props.theme.fontUrls
    .map((font: Record<string, string>) => `
      @font-face {
        font-family: '${font.name}';
        src: local('${font.localName}'),
        url('${font.url}')
      }
    `)}
`
